import { AbstractRepository } from '@/repositories/abstract-repository';
import { Event } from '@/families/events/models/event-models';

export class EventsRepository extends AbstractRepository<Event> {
    readonly endpoint = 'events';

}
